<template>
    <b-container>
        <b-row>
            <b-col cols="12">
                <transition name="fade" mode="out-in">
                    <section class="padding-vertical-content lightgray-content" key="pago" id="pago">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                                    <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                                    <PagoPaycometComponent
                                        ref="pago"
                                        tipo_venta="parcelas"
                                        :jet_id="jet_id"
                                        :session_id="session_id"
                                    />		
                                </div>
                            </div>
                        </div>
                    </section>
                </transition>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import PagoPaycometComponent from '@/components/frontend/compra/components/PagoPaycometComponent';

    export default {
        props: {
            jet_id: {
                type: String,
                required: true
            }
        },
        computed: {
            session_id() {
                return localStorage.getItem('session_id');
            }
        },
        components: {
            PagoPaycometComponent
        }
    }
</script>